import { markdown, ReactSpecimen } from "catalog";
import { Logo } from "./Logo";
import { primaryColors } from "../theme/colors";
export default () => markdown `

## Logo

${(<ReactSpecimen dark>
    <Logo />
  </ReactSpecimen>)}

### Scaling

The logo scales proportionally to fit within the specified width/height:

${(<ReactSpecimen dark span={2}>
    <Logo height={16}/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark span={2}>
    <Logo width={200} height={50}/>
  </ReactSpecimen>)}

### Color

${(<ReactSpecimen>
    <Logo color={primaryColors.zuerichBlue}/>
  </ReactSpecimen>)}



`;



// WEBPACK FOOTER //
// ./src/components/Logo.docs.tsx